<template>
<div class="mf-picker">
    <div class="mf-picker-panel">
    <div class="mf-picker-choose border-bottom-1px">
        <span class="nowTime" @click="nowTime()">现在出发</span>
        <span class="confirm" @click="confirm()">确定</span>
        <h1 class="mf-picker-title">选择出发时间</h1>
    </div>
    <div class="mf-picker-content">
        <div class="mask-top border-bottom-1px"></div>
        <div class="mask-bottom border-top-1px"></div>
        <div class="wheel-wrapper">
        <div class="wheel">
            <ul class="wheel-scroll diff">
            </ul>
        </div>
        <div class="wheel">
            <ul class="wheel-scroll">
            </ul>
        </div>
        <div class="wheel">
            <ul class="wheel-scroll">
            </ul>
        </div>
        </div>
    </div>
    <div class="mf-picker-footer"></div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  __setItem,
} from "@/utils/index";
import {datePicker, confirmTime} from "../timePicker.js";

export default {
  name: "mf-picker",
  data: () => ({}),
  mounted() {
    datePicker({
      appointDays: 7, //默认可以预约未来7天
      preTime: 20, //默认只能预约10分钟之后,如果两个小时就填120
      disMinute: 5 //分钟的间隔，默认一分钟
    });
  },
  methods: {
    confirm() {
      confirmTime();
      let getNewTime = sessionStorage.getItem('getNewTime');
      this.$emit('nowTime', getNewTime);
    },
    nowTime() {
      __setItem('nowIndex', 0);
      this.$store.commit("nowIndex", 0);
      this.$emit('nowTime', '现在出发');
    }
  }
};
</script>
<style scoped>
.mf-picker .mf-picker-panel {
  position: absolute;
  z-index: 66666;
  bottom: 0;
  width: 100%;
  height: 273px;
  background: #fff;
  box-shadow:0px -2px 4px 0px rgba(0,0,0,0.1);
  border-radius:10px 10px 0px 0px;
}

.mf-picker .mf-picker-panel .mf-picker-choose {
  position: relative;
  height: 60px;
  color: #999;
}

.mf-picker .mf-picker-panel .mf-picker-content {
  position: relative;
  top: 20px;
  height: 173px;
}

.border-bottom-1px,
.border-top-1px {
  position: relative;
}

.border-bottom-1px:after,
.border-bottom-1px:before,
.border-top-1px:after,
.border-top-1px:before {
  content: "";
  display: block;
  position: absolute;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}

.border-bottom-1px:after {
  border-bottom: 1px solid #ebebeb;
  left: 0;
  bottom: 0;
  width: 100%;
  -webkit-transform-origin: 0 bottom;
  transform-origin: 0 bottom;
}

.mf-picker .mf-picker-panel .mf-picker-choose .nowTime {
  left: 0;
}

.mf-picker .mf-picker-panel .mf-picker-choose .confirm {
  right: 0;
  color: #fc9153;
}

.mf-picker .mf-picker-panel .mf-picker-choose .mf-picker-title {
  margin: 0;
  line-height: 60px;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  color: #333;
}

.mf-picker .mf-picker-panel .mf-picker-choose .nowTime,
.mf-picker .mf-picker-panel .mf-picker-choose .confirm {
  position: absolute;
  top: 0;
  padding: 16px;
  font-size: 15px;
}
.mf-picker .mf-picker-panel .mf-picker-choose .confirm {
  height: 30px;
  line-height: 30px;
  background: rgba(37,163,255,1);
  border-radius: 2px;
  padding: 0;
  display: inline-block;
  width: 56px;
  margin: 15px;
  color: #fff;
}
.mf-picker .mf-picker-panel .mf-picker-choose .nowTime {
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
  padding: 0 7px;
  font-size: 14px;
  display: inline-block;
  margin: 15px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid rgba(192,192,192,1);
}

.mf-picker .mf-picker-panel .mf-picker-content .mask-top {
  position: absolute;
  top: 0;
  background: -webkit-linear-gradient(
    bottom,
    hsla(0, 0%, 100%, 0.4),
    hsla(0, 0%, 100%, 0.8)
  );
  background: linear-gradient(
    bottom,
    hsla(0, 0%, 100%, 0.4),
    hsla(0, 0%, 100%, 0.8)
  );
}

.mf-picker .mf-picker-panel .mf-picker-content .mask-bottom {
  position: absolute;
  bottom: 1px;
  background: -webkit-linear-gradient(
    top,
    hsla(0, 0%, 100%, 0.4),
    hsla(0, 0%, 100%, 0.8)
  );
  background: linear-gradient(
    top,
    hsla(0, 0%, 100%, 0.4),
    hsla(0, 0%, 100%, 0.8)
  );
}

.mf-picker .mf-picker-panel .mf-picker-content .mask-bottom,
.mf-picker .mf-picker-panel .mf-picker-content .mask-top {
  z-index: 10;
  width: 100%;
  height: 68px;
  pointer-events: none;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.border-top-1px:before {
  border-top: 1px solid #ebebeb;
  left: 0;
  top: 0;
  width: 100%;
}

.mf-picker .mf-picker-panel .wheel-wrapper {
  display: -webkit-box;
  display: flex;
  padding: 0 16px;
}

.mf-picker .mf-picker-panel .wheel-wrapper .wheel {
  flex: 1;
  flex-basis: 1e-9px;
  width: 1%;
  height: 173px;
  overflow: hidden;
  font-size: 16px;
}

.mf-picker .mf-picker-panel .wheel-wrapper .wheel:first-child {
  flex: 1.8;
}

.mf-picker .mf-picker-panel .wheel-wrapper .wheel .wheel-scroll {
  padding: 0;
  margin-top: 68px;
  line-height: 36px;
  list-style: none;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.mf-picker .mf-picker-panel .wheel-wrapper .wheel .diff {
  transition-duration: 150ms;
}

.mf-picker .mf-picker-panel .wheel-wrapper .wheel .wheel-scroll .wheel-item {
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/Home/components/time.vue